import { useCallback, useState } from 'react';
import { LayoutTypeIds } from 'src/interfaces';

import {
  DaypartGlobalComponentItem,
  useGetComponentsWithIncludes,
  useGetDaypartGlobalComponents,
} from './api';

export const useDaypartGlobalComponent = (layout_type_id?: number) => {
  const { data: globalDaypartComponentsData } = useGetDaypartGlobalComponents({
    enabled: layout_type_id === LayoutTypeIds.OUTDOOR,
  });

  const [selectedDaypartId, setSelectedDaypartId] = useState<
    number | undefined
  >();
  const [daypartComponents, setDaypartComponents] = useState('');
  const { data: globalComponentsData } = useGetComponentsWithIncludes(
    [`id.list=${daypartComponents}`],
    ['componentTypes'],
    {
      enabled: daypartComponents.length > 0,
    },
  );

  const onChangeDaypart = useCallback(
    (id: number) => {
      setSelectedDaypartId(id);
      const comp = globalDaypartComponentsData
        ?.filter((val: DaypartGlobalComponentItem) => val.daypart_id === id)
        .map((val: DaypartGlobalComponentItem) => val.component_id);
      setDaypartComponents(comp?.join('|') ?? '');
    },
    [globalDaypartComponentsData],
  );

  return { globalComponentsData, onChangeDaypart, selectedDaypartId };
};
